import React, { useState } from 'react';
import { Box, Typography, Grid, Container, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const tabs = [
  {
    label: 'Developers',
    icon: '🏗️',
    features: [
      { t: 'Project & Tower Management', d: 'Manage multiple projects, towers, floors and unit types with live inventory.' },
      { t: 'Booking to Registration Flow', d: 'Automate booking, agreement, payment schedules and registration workflow.' },
      { t: 'Third-party Integration', d: 'Connect to MagicBricks, 99acres, NoBroker and other property portals.' },
      { t: 'Commission Management', d: 'Track broker commissions, payout schedules and invoice generation.' },
    ],
  },
  {
    label: 'Brokers & Agents',
    icon: '🤝',
    features: [
      { t: 'Lead Registration & Ownership', d: 'Register leads under your name to claim commissions on closures.' },
      { t: 'Client Follow-up Tracker', d: 'Never miss a callback with automated reminders and pipeline view.' },
      { t: 'Site Visit Scheduling', d: 'Book and manage property site visits with automated confirmation messages.' },
      { t: 'Performance Dashboard', d: 'Track your leads, conversions, and earnings with a personal dashboard.' },
    ],
  },
  {
    label: 'Sales Teams',
    icon: '📊',
    features: [
      { t: 'Team Lead Distribution', d: 'Managers can assign and redistribute leads across the sales team.' },
      { t: 'Call Log Sync', d: "All customer calls automatically logged from the sales rep's phone." },
      { t: 'Target vs Achievement', d: 'Real-time tracking of monthly targets, achievements, and gaps.' },
      { t: 'WhatsApp Follow-up', d: 'Send personalized WhatsApp messages from within the CRM platform.' },
    ],
  },
];

const FeatureTabs = () => {
  const [active, setActive] = useState(0);
  return (
    <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: '#fff' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography sx={{ color: '#0891b2', fontWeight: 700, fontSize: 13, letterSpacing: 2, mb: 1.5, fontFamily: "'Montserrat', sans-serif", textTransform: 'uppercase' }}>Built For Every Role</Typography>
          <Typography variant="h2" sx={{ fontWeight: 800, color: '#0f172a', fontFamily: "'Montserrat', sans-serif", fontSize: { xs: '1.8rem', md: '2.6rem' } }}>
            Tailored Features for Your Team
          </Typography>
        </Box>

        {/* Tab Buttons */}
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 6, flexWrap: 'wrap' }}>
          {tabs.map((t, i) => (
            <Button key={i} onClick={() => setActive(i)}
              sx={{
                px: 4, py: 1.5, borderRadius: '14px', fontFamily: "'Montserrat', sans-serif", fontWeight: 700, fontSize: 15,
                bgcolor: active === i ? '#0891b2' : '#f1f5f9',
                color: active === i ? '#fff' : '#475569',
                boxShadow: active === i ? '0 8px 24px rgba(8,145,178,0.35)' : 'none',
                border: active === i ? '2px solid #0891b2' : '2px solid transparent',
                '&:hover': { bgcolor: active === i ? '#0e7490' : '#e2e8f0' },
                transition: 'all 0.2s',
              }}>
              <Box component="span" sx={{ mr: 1 }}>{t.icon}</Box>{t.label}
            </Button>
          ))}
        </Box>

        {/* Cards — all SAME HEIGHT using Grid with alignItems stretch + height 100% on card */}
        <Grid container spacing={3} alignItems="stretch">
          {tabs[active].features.map((f, i) => (
            <Grid item xs={12} sm={6} key={i} sx={{ display: 'flex' }}>
              <Box sx={{
                display: 'flex', gap: 2, p: 3.5,
                bgcolor: '#f8fafc', borderRadius: '16px',
                border: '1px solid #e2e8f0',
                width: '100%',
                transition: 'all 0.2s',
                '&:hover': { bgcolor: '#fff', boxShadow: '0 8px 32px rgba(8,145,178,0.1)', borderColor: 'rgba(8,145,178,0.3)', transform: 'translateY(-3px)' },
              }}>
                <Box sx={{ flexShrink: 0, mt: '2px' }}>
                  <Box sx={{ width: 40, height: 40, borderRadius: '12px', bgcolor: '#e0f2fe', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <CheckCircleIcon sx={{ color: '#0891b2', fontSize: 22 }} />
                  </Box>
                </Box>
                <Box>
                  <Typography sx={{ fontWeight: 800, color: '#0f172a', fontFamily: "'Montserrat', sans-serif", fontSize: '0.97rem', mb: 0.8 }}>{f.t}</Typography>
                  <Typography sx={{ color: '#64748b', fontFamily: "'Montserrat', sans-serif", fontSize: 14, lineHeight: 1.6 }}>{f.d}</Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default FeatureTabs;
